import { render, staticRenderFns } from "./EmployeesCompany.vue?vue&type=template&id=274bab68"
import script from "./EmployeesCompany.vue?vue&type=script&lang=js"
export * from "./EmployeesCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports